<div class="error-block">
  <app-logo></app-logo>
  <div class="error-role-block">
    <i class="pi pi-times-circle"></i>
    <p i18n>Отсутствуют права по работе с документами</p>
  </div>
</div>
